"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _types = require("../actions/types");
var _chatReducer = _interopRequireDefault(require("./chatReducer"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var initialState = {};
var _groupChatsByRoomName = function _groupChatsByRoomName(chats) {
  return chats.reduce(function (acc, chat) {
    var roomname = chat.roomname;
    acc[roomname] = chat;
    return acc;
  }, {});
};
var chatsByRoomNameReducer = function chatsByRoomNameReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var type = action.type,
    _action$value = action.value,
    value = _action$value === void 0 ? {} : _action$value;
  switch (type) {
    case _types.FAVORITE_CHAT:
      {
        var _value$chat = value.chat,
          chat = _value$chat === void 0 ? {} : _value$chat;
        var roomname = chat.roomname;
        if (roomname) {
          var updatedChat = _objectSpread(_objectSpread({}, state[roomname]), {}, {
            isFavoriteChat: !state[roomname].isFavoriteChat
          });
          return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, roomname, updatedChat));
        }
        return state;
      }
    case _types.LOAD_CHAT_DONE:
    case _types.JOIN_ROOM_DONE:
    case _types.LOAD_CHAT_ERROR:
      {
        var _value$chat2 = value.chat,
          _chat = _value$chat2 === void 0 ? {} : _value$chat2;
        var _roomname = _chat.roomname;
        if (_roomname) {
          return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, _roomname, (0, _chatReducer["default"])(state[_roomname], action)));
        }
        return state;
      }
    case _types.RECEIVE_CHATS:
      {
        var _value$chats = value.chats,
          chats = _value$chats === void 0 ? [] : _value$chats;
        var chatsByRoomName = _groupChatsByRoomName(chats);
        return _objectSpread(_objectSpread({}, state), chatsByRoomName);
      }
    case _types.RECEIVE_MESSAGES:
      {
        var _value$messages = value.messages,
          messages = _value$messages === void 0 ? [] : _value$messages;
        var _messages = _slicedToArray(messages, 1),
          message = _messages[0];
        var _roomname2 = message.roomname;
        var _chat2 = (0, _chatReducer["default"])(state[_roomname2], action);
        if (state[_roomname2] && _chat2 !== state[_roomname2]) {
          return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, _roomname2, _chat2));
        }
        return state;
      }
    case _types.UPDATE_CHAT_MESSAGES_LOADED:
    case _types.UPDATE_CHAT_LAST_SEEN:
      {
        var _value$roomname = value.roomname,
          _roomname3 = _value$roomname === void 0 ? '' : _value$roomname;
        if (_roomname3) {
          var _chat3 = (0, _chatReducer["default"])(state[_roomname3], action);
          return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, _roomname3, _chat3));
        }
        return state;
      }
    case _types.REMOVE_CHAT:
      {
        var _value$roomname2 = value.roomname,
          _roomname4 = _value$roomname2 === void 0 ? '' : _value$roomname2;
        var newState = state;
        delete newState[_roomname4];
        return newState;
      }
    case _types.ADD_BUTTONS:
      {
        var _roomname5 = value.roomname,
          buttons = value.buttons;
        if (_roomname5) {
          var _chat4 = (0, _chatReducer["default"])(state[_roomname5], action);
          var newChat = _objectSpread(_objectSpread({}, _chat4), {}, {
            buttons: buttons
          });
          return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, _roomname5, newChat));
        }
        return state;
      }
    default:
      return state;
  }
};
var _default = exports["default"] = chatsByRoomNameReducer;